import React, { useState, useEffect, Fragment } from "react";

const useLeaveTypeTable = (
    leavetypeData,
    handleDelLeaves,
    handleEditLeaves,
    onClickToggleFromTable
) => {
  const [thead] = useState(["Leave Type", "Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
    let trowArr = Array.from(leavetypeData).map((el) => {
      return {
        "Leave Type": el.leaveType,
     
        Action: (
          <Fragment>
            <i
              className="fas fa-edit ml-4" 
              style={{ marginRight: "10px", cursor: "pointer" }}             
              onClick={() => {
                handleEditLeaves(el, el.id);
                onClickToggleFromTable();
             }}
            >&nbsp;</i>
            <i
              className="fas fa-trash"
              onClick={() => handleDelLeaves(el.id,el)}
            ></i>
            
          </Fragment>
        ),
      };
    });

     setTrow(trowArr);
  }, [
    leavetypeData,
    handleDelLeaves,
    handleEditLeaves,
    onClickToggleFromTable
  ]);

  return { thead, trow };
};

export default useLeaveTypeTable;